
export class XPathCalc {
	basePath: string
	tagCount: {[tagName: string]: number} = {}

	constructor(basePath: string) {
		this.basePath = basePath
	}

	getNext(tagName: string): string {
		if(!this.tagCount.hasOwnProperty(tagName)) {
			this.tagCount[tagName] = -1
		}
		return `${this.basePath}.${tagName}[${++this.tagCount[tagName]}]`
	}
}
